import { IHavingRule } from '../rule-interface';
import { IRuleProps } from '../rule-props';
import { IResultTypeUsage } from '../../query/search-result-type/result-type-options';
import { getFields } from '../get-fields';
import { useTransform } from '../../../../../hooks';
import { useQueryBuilderContext } from '../query-builder-context';

/**
 * Resolves the fields of a having group's type and the types that can be nested inside it.
 * `allTypes` must be the complete list of types in the universe, not the types allowed at the
 * current level, otherwise types nested deeper than one level below cannot be found.
 */
export function getFieldsAndTypes(allTypes: IResultTypeUsage[], type: string | undefined) {
  const selectedType = allTypes.find(x => x.name === type);
  if (selectedType && selectedType.fields) {
    const childLists = selectedType.fields.filter(x => x.isList).map(x => x.name);

    return {
      fields: getFields(selectedType.fields),
      types: allTypes.filter(x => childLists.includes(x.name)),
    };
  }

  return { fields: [], types: [] };
}

export function useFieldsAndTypes(props: IRuleProps<IHavingRule>) {
  const { types: allTypes } = useQueryBuilderContext();
  const {
    value: { type },
  } = props;
  return useTransform(getFieldsAndTypes, allTypes, type);
}
